/*******************************************************************************
TRIGGER THE SELECTED TAB ON WINDOW RESIZE
Activates the tab that is designated as the selected one for the current screen size.
*******************************************************************************/

import triggerSelectedTab from './trigger-selected-tab';

const resizeTimer = {};

export default function triggerSelectedTabOnResize() {

    // Loop through all the toggle tab sets that have responsive breakpoints on them
    $('.toggle-tabs[data-sel-bp-exists]').each(function loopToggleTabSets() {
        const $tabs = $(this);
        const tabSetName = $tabs.data('name');

        clearTimeout(resizeTimer[tabSetName]);
        resizeTimer[tabSetName] = setTimeout(() => { triggerSelectedTab(tabSetName); }, 250);
    });
}
